import styled from 'styled-components/macro';

const CancelButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 15px;
  height: 15px;
  padding: 0 3px;
  background-color: transparent;
  border: 0;
  color: #fff;
  opacity: 0.6;
  cursor: pointer;
  line-height: 8px;
  transform: scale(0.6);
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }
`;

export default CancelButton;
